<template>
  <div class="distribution">
    <div id="map"></div>
  </div>
</template>

<script>
// 数据格式
import * as echarts from "echarts";
import { worldNameMap, worldGeoMap } from "@/assets/map/worldNameMap.js";
import { getDistribution } from "@/api/distribution.js";
import worldMapJson from "@/assets/map/world.json";
export default {
  name: "distribution",
  data() {
    return {
      worldNameMap,
      worldGeoMap,
      mapdata: [],
    };
  },
  created(){
 

  },
  mounted() {
    getDistribution().then((res) => {
      this.mapdata = res.data.data.result;
      this.initData();
    });
  },

  methods: {
    initData() {
      var map = document.querySelector("#map");
      let chartDom = echarts.init(map);
      let riskData = this.mapdata.map((item) => {
        if (item.CnName == "" && item.EnName == "") {
            return{
                name:"",
                value:""
            }
        } else {
          return {
            name: item.CnName,
            value: item.Total,
          };
        }
      });
      // [
      //     { name: "中国", value: 120 },
      //     { name: "澳大利亚", value: 120 },
      //     { name: "巴西", value: 170 },
      //     { name: "加拿大", value: 570 },
      //     { name: "美国", value: 570 },
      //     { name: "墨西哥", value: 570 },
      //     { name: "古巴", value: 530 },
      //     { name: "西班牙", value: 70 },
      //   ];
      let markPointData = [
        {
          name: "中国",
          coord: this.worldGeoMap["中国"],
          //   symbol: "image://" + icon,
          symbolSize: 20,
        },
        {
          name: "澳大利亚",
          coord: this.worldGeoMap["澳大利亚"],
          //   symbol: "image://" + icon,
          symbolSize: 20,
        },
        {
          name: "加拿大",
          coord: this.worldGeoMap["加拿大"],
          //   symbol: "image://" + icon,
          symbolSize: 20,
        },
      ];
      echarts.registerMap("world", worldMapJson);
      let option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
          },
          borderWidth: 2,
          borderColor: "#ECECEE",
          padding: 10,
          formatter: function (params) {
            var value = params.value ? params.value : 0;
            return "分布情况<br/>" + params.name + " : " + value + "个";
          },
        },
        visualMap: {
          type: "piecewise",
          splitNumber: 3,
          inverse: true,
          right: 50,
          top: 50,
          pieces: [
            {
              min: 0,
              max: 300,
              color: "rgb(200,200,169)",
            },
            {
              min: 300,
              max: 700,
              color: "rgb(131,175,155)",
            },
            {
              min: 700,
              max: 1000,
              color: "rgb(252,157,154)",
            },
            {
              min: 1000,
              max: 1200,
              color: "rgb(254,67,101)",
            },
          ],
          textStyle: {
            color: "#6E7784",
          },
          itemWidth: 40,
          itemHeight: 10,
          align: "left",
        },
        series: [
          {
            type: "map",
            map: "world",
            nameMap: this.worldNameMap,
            roam: true,
            itemStyle: {
              areaColor: "#dfe2f5",
              borderWidth: 0,
              emphasis: {
                label: {
                  show: false,
                },
                areaColor: "#feddb3",
              },
            },
            // markPoint: { //标记
            //   label: {
            //     normal: {
            //       show: true,
            //     },
            //     emphasis: {
            //       show: true,
            //     },
            //   },
            //   itemStyle: {
            //     normal: {
            //       color: "rgba(72,150,128,1)",
            //     },
            //   },
            //   data: markPointData,
            // },
            data: riskData,
          },
        ],
      };
      chartDom && chartDom.setOption(option);
      let sizeFun = () => {
        chartDom.resize();
      };
      window.addEventListener("resize", sizeFun);
      this.$once("hook:beforeDestroy", function () {
        echarts.dispose(chartDom);
      });
    },
  },
};
</script>

<style lang="less">
.distribution{
  height: 100%;
  #map {
  width: 100%;
  height: 100%;
}

}

</style>